import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MakingDataService } from '../../md/service/making-data.service';
import { Mainservice2Service } from './mainservice2.service';
import { TokenService } from '../../token.service';
import * as numberToWords from 'number-to-words';
import { toWords } from 'number-to-words';

@Injectable({
  providedIn: 'root'
})
export class ClerkNocService {

  httpUrl: any;
  erpUser: any;
  b_acct_id: any;
  file_id:any;
  URL :any;
  Obj : any = {};
  data_status : boolean = true;
  role_bill:boolean = false;
  setData(url:any){
    this.URL = url;
  }
  constructor(private http: HttpClient, private main: Mainservice2Service, private token: TokenService,
    private sanitizer: DomSanitizer, private mds: MakingDataService) {
    this.httpUrl = this.main.httpUrl;
  }

  async insertnocfiledata(obj: any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/insert_registration', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getmaxfileid(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getmaxfileid' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getallclerkfiledata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getallclerkfiledata' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getfiledatabyfileid(obj: any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/getfiledatabyfileid' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async changefilestatus(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/noc/file_details/changefilestatus', obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async changedeptstatus(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/noc/file_details/deptchangestatus', obj).toPromise().then(res => {
       return res
    });
    return resp
  }
  async get_file_details(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getfile_details' + obj).toPromise().then(res => {

      return res
    });
    return resp
  }

  async getallworkflowuser(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getallworkflowuser'+ obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async get_all_notesheet(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getall_notesheet' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async UPDATEnocfiledata(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/noc/file_details/UPDATEnocfiledata', obj).toPromise().then(res => {
       return res
    });
    return resp
  }

  async supporting_doc(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/supporting_doc' + obj).toPromise().then(res => {

      return res
    });
    return resp
  }

  async adding_document(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/adding_doc' + obj).toPromise().then(res => {

      return res
    });
    return resp
  }

  async rejectfile(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/noc/file_details/rejectfile', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getnode_cd(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getnodecd' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async changelastleveldeptstatus(obj: any) {
    const resp = this.http.put<any>(this.main.httpUrl2 + '/noc/file_details/changelastleveldeptstatus', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getworkflowid(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getallworklowidbyuser' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }
  async getalldataafterapprvl(obj:any) {
    const res = await this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getalldataafterapprvl' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async viewCorrespondence(obj :any) {
    console.log(obj, "from service")
    const resp = await this.http.post(this.main.httpUrl2 + '/noc/file_details/view_document', obj, { responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async generate_bill(obj: any) {
    const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/insert_bill', obj).toPromise().then(res => {
      return res
    });
    return resp
  }
// ///////////////////////////////////////////////////////////////////////////////////////////////////
async getallbill(obj:any) {
  const res = await this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/get_all_bill' + obj).toPromise().then(res => {
    return res;
  });
  return res;
}

async getlogophoto() {
  const resp = await this.http.get('./assets/nagar_nigam_logo.jpg', { responseType: 'blob' }).toPromise().then(res => {
    return res
  });
  return resp
}
async getnoccertifphoto() {
  const resp = await this.http.get('./assets/nagar_nigam_logo.png', { responseType: 'blob' }).toPromise().then(res => {
    return res
  });
  return resp
}

  async getdepartmentdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getdepartmentdata' + obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async getworkflowloguser(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getworkflowloguser'+ obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  async getlastlevependingdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getlastlevependingdata'+ obj).toPromise().then(res => {
      return res
    });
    return resp
  }


  async getchief_eng_billdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getchiefengbilldata'+ obj).toPromise().then(res => {
      return res
    });
    return resp
  }



  async getallpaymentdata(obj: any) {
    const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getallpaymentdata'+ obj).toPromise().then(res => {
      return res
    });
    return resp
  }

  // async getprintdata(obj: any): Promise<Blob> {
  //   console.log(obj,"datattt");
    
  //   // const options = {
  //   //   headers: new HttpHeaders({
  //   //     'Content-Type': 'application/json'
  //   //   }),
  //   //   responseType: 'blob' as 'json'
  //   // };
  
  //   // Issue might be here: ensure `obj` is properly appended to the URL
  //   // Assuming `obj` is an object, you might need to convert it to query parameters
  
  //   try {
  //     console.log(obj,"dafffffffftattt");
  //     // Use proper URL encoding for `obj` if it's supposed to be part of the URL
  //     const url = `${this.main.httpUrl2}/noc/file_details/getprintdata?${new URLSearchParams(obj).toString()}`;
  
  //     // Make the HTTP GET request with the options
  //     const response = await this.http.post<Blob>(url,obj).toPromise();
  
  //     // Check if response is undefined
  //     if (!response) {
  //       throw new Error('Response is undefined');
  //     }
  
  //     // Return the response
  //     return response;
  //   } catch (error) {
  //     // Handle errors here
  //     console.error('Error fetching print data:', error);
  //     throw error; // Re-throw the error or handle it according to your application's logic
  //   }
  // }
  
  async getprintdata(obj: any) {
    const resp = this.http.post(this.main.httpUrl2 + '/noc/file_details/getprintdata' , obj).toPromise().then(res => {
      return res
    });
    return resp
  }

//////////////////////////////////////////dashborad data//////////////////////////////////////////////////////
async getdashboarddata(obj: any) {
  const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/getdashboarddata' + obj).toPromise().then(res => {
    return res
  });
  return resp
}









/////////////////////////////////////convert number to word////////////////////////////////////////
async  convertToWords() {
    if (this.Obj['bill_amount'] != null) {
      this.Obj['bill_word'] = this.convertToIndianWords(this.Obj['bill_amount']);
    } else {
      this.Obj['bill_word'];
    }
  }



convertToIndianWords(num: number): string {
  // Convert number to words using the library
  let words = toWords(num);

  // Optional: Adjust for Indian numbering system
  return this.adjustToIndianNumbering(words);
}

adjustToIndianNumbering(words: string): string {
  // Replace 'thousand' with 'thousand', 'million' with 'lakh', and 'billion' with 'crore'
  const indianNumberingWords = words.replace(/million/g, 'lakh').replace(/billion/g, 'crore');

  return indianNumberingWords;
}

  // convertToIndianWords(num: number): string {
  //   // Convert number to words using the library
  //   let words = numberToWords.toWords(num);

  //   // Optional: Adjust for Indian numbering system
  //   return this.adjustToIndianNumbering(words, num);
  // }

  // adjustToIndianNumbering(words: string, num: number): string {
  //   // Split the words into an array
  //   const wordsArray = words.split(' ');

  //   // Replace 'thousand' with 'thousand', 'million' with 'lakh', and 'billion' with 'crore'
  //   const indianNumberingWords = wordsArray.map(word => {
  //     switch (word) {
  //       case 'thousand':
  //         return 'Thousand';
  //       case 'million':
  //         return 'Lakh';
  //       case 'billion':
  //         return 'Crore';
  //       default:
  //         return word;
  //     }
  //   });

  //   // Join the words back into a string
  //   return indianNumberingWords.join(' ');
  // }

//////////////////////////////////////////////////send mail//////////////////////////////////////



async sendmail(obj:any) {
  // const emailData = { to, subject, text };
  const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/sendmail', obj).toPromise().then(res => {
    return res
  });
  return resp
}
async last_level_approval_from_property(obj: any) {
  const resp = this.http.get<any>(this.main.httpUrl2 + '/noc/file_details/lastlevelapprovedfromproerty' + obj).toPromise().then(res => {
    return res
  });
  return resp
}

async insert_housetax(obj: any) {
  const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/insert_house_tax' , obj).toPromise().then(res => {
    return res
  });
  return resp
}
async cartographer_insert_data(obj: any) {
  const resp = this.http.post<any>(this.main.httpUrl2 + '/noc/file_details/cartographer_insert_data', obj).toPromise().then(res => {
     return res
  });
  return resp
}




}
